import "react-app-polyfill/ie9"; // For IE 9-11 support
import "react-app-polyfill/ie11"; // For IE 11 support

import React from "react";
import ReactDOM from "react-dom";

import "./index.css";
import "./mixin.styl";
import App from "./App";
import { Provider } from "mobx-react";
import RootStore from "./pages/viewer-dashboard/store/rootStore";
import * as serviceWorker from "./serviceWorker";
import Config from "config";
import { getTime } from "apis/time";
/// Store간 연계를 위한 Root Store 생성.
getTime()
  .then((value) => {})
  .catch((reason) => {
    console.log(reason);
  });
const root = new RootStore();
Config.rootStore = root;
ReactDOM.render(
  // 스토어 연결
  <Provider {...root}>
    {/* root 요소에 Application 렌더링 */}
    <App />
  </Provider>,
  document.getElementById("root")
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
//serviceWorker.register();
